import { theme as iconTheme } from '@clds/icon';

const styleMapping = {
  sm: {
    toggle: iconTheme.bySize.xs.width,
    more: iconTheme.bySize.xs.width,
    icon: iconTheme.bySize.sm.width,
    spacing: 'spacing.xs',
    height: '32px',
  },
  md: {
    toggle: iconTheme.bySize.xs.width,
    more: iconTheme.bySize.xs.width,
    icon: iconTheme.bySize.md.width,
    spacing: 'spacing.xs',
    height: '40px',
  },
};

export default styleMapping;
